import { render, staticRenderFns } from "./TemplateEntrance.vue?vue&type=template&id=323f2110&scoped=true"
import script from "./TemplateEntrance.vue?vue&type=script&lang=js"
export * from "./TemplateEntrance.vue?vue&type=script&lang=js"
import style0 from "./TemplateEntrance.vue?vue&type=style&index=0&id=323f2110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f2110",
  null
  
)

export default component.exports